<template>
  <p
    v-if="document?.name in DOCUMENT_NAMES"
    class="hr-document-module-info"
    data-test-id="hr-document-module-info"
  >
    <co-icon class="__info-icon" name="information"></co-icon>
    {{
      t(`hr-document-module-info:DOCUMENTS:${DOCUMENT_NAMES[document?.name]}`)
    }}
  </p>
</template>

<script>
import t from '@/lib/i18next';
import { CoIcon } from '@deputy/copilot2';

export default {
  components: {
    CoIcon,
  },
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const DOCUMENT_NAMES = {
      fileUploads: 'FILE_UPLOAD',
    };
    return {
      t,
      DOCUMENT_NAMES,
    };
  },
};
</script>

<style scoped>
.hr-document-module-info {
  margin-bottom: 32px;
  color: var(--co-text-secondary);
}
.co-icon.__info-icon {
  width: 18px;
  height: 18px;
  vertical-align: bottom;
  color: var(--co-button-primary-fill);
}
</style>
